import { NewsContentType } from '@/types/enum';
import carouselImage1 from '@/assets/images/news/hot/hot1.jpg';


export default {
  id: '20210415', //  模块 id
  title: '上海海洋大学“叮咚买菜奖教奖学金”获奖名单公布，校企携手助力研究成果落地', // 标题
  origin: '2022-01-18 18:10:26 来源：文汇报', // 新闻来源
  editor: '编辑：祝越', // 编辑者
  content: [
    {
      type: NewsContentType.Image,
      src: [carouselImage1],
    },

    {
      type: NewsContentType.Text,
      text:
        '近日，上海海洋大学公布了2021年度“叮咚买菜奖教奖学金”获奖名单。获奖的8位上海海洋大学师生，多为在水产与生命科学领域深耕多年的研究人员，他们的数项研究成果目前在与叮咚买菜的交流合作中，从实验室走向了江河湖海，最终为消费者的餐桌升级增添新美味。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '据介绍，上海海洋大学“叮咚买菜奖教奖学金”于2021年5月设立，主要用于奖励在水产研究领域有突出成果的优秀教师与学生。这也是国内首个生鲜供应链企业设立高校专项奖金，用于支持水产科学研究和专业人才的培养。此次获奖的为该校师生王成辉、陈乃松、罗国芝、沈和定、胡鲲、孙大川、季涛、许津源8人，分获“叮咚买菜奖教奖学金”产业贡献奖及创新创业奖，两个奖项合计颁发奖金共计14万元。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text: '来自育种系的获奖人王成辉教授，是此次获奖人之一。他还有另一个身份——叮咚买菜订单养殖“江海21”大闸蟹的“爸爸”。作为上海市中华绒螯蟹现代农业产业技术体系的首席专家，他带领团队成员深入养殖基地和养蟹池塘，开创了上海和全国生产优质清水大闸蟹的局面，促进我国河蟹产业走科技养蟹、质量兴蟹、绿色强蟹、品牌促蟹的新型发展之路，推动我国河蟹产业从“大养蟹”，到“养大蟹”，再到“养名蟹”的发展新历程。其选育的品种“江海21”扬州宝应生产基地正是叮咚买菜全国首个大闸蟹订单农业项目，开创了河蟹产业由传统养殖模式向订单化养殖新模式转型。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '而广受叮咚买菜宝妈用户好评的优饲鲈鱼，则是另一位获奖人陈乃松教授研究成果的落地转化。陈乃松教授主要从事于肉食性鱼类营养与饲料加工工艺的研究，先后主持特色淡水鱼产业体系淡水鲈营养需求与饲料岗位、上海市农委重点攻关、上海市科委高校能力建设项目等国家级或省部级项目，其研发的大口黑鲈、大黄鱼和石斑鱼全价配合饲料在生产中能完全替代现行的冰鲜杂鱼饲料，获得了良好的经济和社会效益。鲈鱼优质饲料的研发对叮咚买菜今年能够推出优饲鲈鱼、打造“宝妈严选”优质水产系列具有重要的指导作用。',
    },
    {
      type: 2,
    },
    {
      type: NewsContentType.Text,
      text:
        '产研结合，是践行创新发展的关键环节。叮咚买菜设立奖教奖学金，初衷正是支持高校为水产领域培养出更多优秀人才，做出更多创新成果；同时，通过奖项的设立，校企双方也能合作交流，结合市场需求促进研究成果的落地转化，使其焕发出新的生命力。据了解，未来，叮咚买菜还将与上海海洋大学继续深入合作，为国内水产行业的创新发展携手共进。-196℃液氮保鲜，保证虾的Q弹与鲜美；12小时之内就能从湖北发往叮咚买菜位于全国各地的大仓，不到48小时，就能通过叮咚买菜的1000多家前置仓送达每个家庭的餐桌。',
    },
  ],
};
